import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Dispatch, SetStateAction } from 'react';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import { faClipboardList } from '@fortawesome/pro-solid-svg-icons';

export interface NewContentPlanButtonProps {
  setNewContentPlanOpen: Dispatch<SetStateAction<boolean>>;
  hasExistingPlan: boolean;
  disabled?: boolean;
}

export const NewContentPlanButton: React.FC<NewContentPlanButtonProps> = ({
  setNewContentPlanOpen,
  hasExistingPlan,
  disabled,
}) => {
  return (
    <VoxelButton
      onClick={() => setNewContentPlanOpen(true)}
      endIcon={<FontAwesomeIcon icon={faClipboardList} size={hasExistingPlan ? 'sm' : 'lg'} />}
      title={hasExistingPlan ? 'New content plan' : 'Create content plan'}
      size={hasExistingPlan ? 'md' : 'lg'}
      color="primary"
      disabled={disabled}
    />
  );
};

export default NewContentPlanButton;
